
export const formatCurrency = (num?: number) => {
    if (num === undefined || num === null || Number.isNaN(num)) {
        return "-";
    }
   return new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);
}

export const parseDisplay = (text: string): number | undefined => {
    // Acepta tanto "1.234,56" (es-ES) como "1234,56" o "1234.56"
    let cleaned = text.replace(/[^\d.,]/g, "");
    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");

    if (hasComma && hasDot) {
        // El �ltimo separador es el decimal
        if (cleaned.lastIndexOf(",") > cleaned.lastIndexOf(".")) {
            cleaned = cleaned.replace(/\./g, "").replace(",", ".");
        } else {
            cleaned = cleaned.replace(/,/g, "");
        }
    } else if (hasComma) {
        cleaned = cleaned.replace(",", ".");
    }

    const num = parseFloat(cleaned);
    return isNaN(num) ? undefined : num;
};